/**
 * Reads the API's own message from an RTK Query / axios error, so users see
 * why a request was rejected (e.g. a scheduling conflict) instead of a
 * generic failure. Falls back to `fallback` when there is none.
 */
export const apiErrorMessage = (error: unknown, fallback: string): string => {
  const err = error as {
    data?: unknown;
    response?: { data?: unknown };
  } | null;
  const data = (err?.data ?? err?.response?.data) as
    | {
        message?: unknown;
        error?: { message?: unknown };
        detail?: unknown;
      }
    | undefined;

  if (typeof data?.error?.message === "string" && data.error.message) {
    return data.error.message;
  }
  if (typeof data?.message === "string" && data.message) {
    return data.message;
  }
  if (typeof data?.detail === "string" && data.detail) {
    return data.detail;
  }
  if (Array.isArray(data?.detail)) {
    const first = data.detail[0] as { msg?: unknown } | undefined;
    if (typeof first?.msg === "string") {
      return first.msg.replace(/^Value error,\s*/, "");
    }
  }
  return fallback;
};
